(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('NexaasFactory', NexaasFactory);

    NexaasFactory.$inject = ['$resource'];

    function NexaasFactory($resource) {
        var resourceUrl = 'flyer/api/integration/nexass';

        return $resource(resourceUrl, {}, {
            'syncProductsByStoreAndFlyerIds': {
                method: 'POST',
                url: resourceUrl + '/sync-products/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();
